export const tabs = [
    { value: "all", title: "All" },
    { value: "PUBLISHED", title: "Published" },
    { value: "DRAFT", title: "Draft" },
  ];